<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <el-tabs type="border-card">
        <el-tab-pane :label="$t('message.' + langItem.langCode)" v-for="(langItem, index) in detailInfo.langMaps"
          :key="index">
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Title </label>
                <div class="col-sm-10">
                  <el-form-item :prop="'langMaps.' + index + '.title'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  }">
                    <el-input v-model="langItem.title" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Cover Image </label>
                <div class="col-sm-10">
                  <el-upload class="upload-demo upload-image" action="#" multiple :http-request="uploadFile"
                    :auto-upload="true" accept=".png, .jpg , .jpeg" :show-file-list="false">
                    <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The
                      uploaded
                      file should not exceed 5MB</div>
                    <div class="input-group img-group">
                      <div class="text-center dropzone logo">
                        <div class="addImage" v-if="!detailInfo.frontCoverImg.fullFileUrl"
                          style="width: 100%; padding-top: 25px; color: #fff">
                          <a class="addImageIcon btn btn-primary btn-circle">
                            <i class="el-icon-upload2"></i>
                          </a>
                          <p class="text-primary m-t-sm font14 suggestFont">
                            <slot name="sizeHint"></slot>
                          </p>
                        </div>
                        <div class="editImage" v-if="detailInfo.frontCoverImg.fullFileUrl">
                          <div class="mask-bg"></div>
                          <img :src="detailInfo.frontCoverImg.fullFileUrl" />
                          <div class="icon-center">
                            <span class="edit-icon">
                              <i class="el-icon-edit"></i>
                            </span>
                            <p class="font14 font-white editFont">Modify</p>
                            <p class="text-primary font-white m-t-sm font14 suggestFont">
                              <slot name="sizeHint"></slot>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-upload>
                  <el-form-item :prop="'frontCoverImg.fullFileUrl'" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change',
                  }">
                    <el-input style="display: none" v-model="detailInfo.frontCoverImg.fullFileUrl"
                      show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Status </label>
                <div class="col-sm-4">
                  <el-form-item prop="status" :rules="{
                    required: false,
                    message: $t('message.required'),
                    trigger: 'change',
                  }">
                    <el-select v-model="detailInfo.status" disabled v-bind:placeholder="$t('message.PleaseSelect')">
                      <el-option v-for="item in statusObj" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button type="primary" @click="checkEvent()" :disabled="!(
                      !detailInfo.status ||
                      detailInfo.status == 3 ||
                      detailInfo.status == 4
                    )
                      " v-if="(checkPermission('J Channel_EDIT') &&
                        $route.query.id) ||
                        (checkPermission('J Channel_LIST_ADD') &&
                          !$route.query.id)
                      ">Save</el-button>
                    <el-button @click="showWarning()">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-collapse v-model="activeNames" v-show="detailInfo.id">
            <el-collapse-item title="Sub Section List" name="1">
              <div class="col-sm-12">
                <div class="float-e-margins">
                  <div class="ibox-content">
                    <div class="row table-responsive" style="padding-bottom: 60px">
                      <div class="form-group  margin-0">
                        <label class="col-sm-2 control-label">
                          Title
                        </label>
                        <div class="col-sm-4">
                          <div>
                            <el-input v-model="searchName" name="search"></el-input>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class>
                            <el-button type="primary" @click="handleCurrentChange(1)">{{
                              $t("message.Search")
                            }}</el-button>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="pull-right">
                          <el-button @click="gotoSubDetail" v-if="checkPermission('J Channel_LIST_ADD')">{{
                            $t("message.Add") }}</el-button>
                          <el-button @click="Delete" v-if="checkPermission('J Channel_LIST_DEL')">{{
                            $t("message.Delete")
                          }}</el-button>
                        </div>
                      </div>
                      <div class="col-xs-12">
                        {{ subGroupList.length
                        }}{{ $t("message.datagridresult") }}
                      </div>
                      <el-table :data="subGroupList" border style="width: 100%" ref="multipleTable"
                        @selection-change="handleSelectionChange" row-key="id" :cell-class-name="cell">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column label="J-Channel Category Title" :show-overflow-tooltip="true" min-width="200">
                          <template slot-scope="scope">
                            <div>
                              <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.expired">
                                Expired
                              </el-tag>
                              {{ scope.row.title }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="endDate" label="Expiry Date" width="170">
                        </el-table-column>
                        <el-table-column prop="updatedAt" label="Last Update Time" width="170">
                        </el-table-column>
                        <el-table-column prop="updatedBy" label="Last Update By" width="170">
                        </el-table-column>
                        <el-table-column prop="statusName" label="Status" min-width="150"></el-table-column>
                        <el-table-column width="250">
                          <template slot-scope="scope">
                            <StatusBtn :id="scope.row.id" :status="scope.row.status" :init="getSubList"
                              :type="'JCHANNEL'" :approval="'J Channel_LIST_APPROVAL'"></StatusBtn>
                          </template>
                        </el-table-column>
                        <el-table-column label="Action" width="120" fixed="right">
                          <template slot-scope="scope">
                            <el-row>
                              <el-col :span="12"><el-button size="mini" @click="handleDbClick(scope.row)"
                                  icon="el-icon-edit"></el-button></el-col>

                              <el-col :span="12" v-if="canDrag">
                                <div class="text-center dragTip">=</div>
                              </el-col>
                            </el-row>
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-col :span="24" class="el-table_footertoolbar">
                        <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                          @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]"
                          :page-size="pagesize" :total="total" style="float: right">
                        </el-pagination>
                      </el-col>
                    </div>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import Sortable from "sortablejs";
import StatusBtn from "../components/common/statusBtn.vue";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      detailInfo: {
        parentId: 0,
        beginDate: null,
        endDate: null,
        status: 0,
        recommendedEventCategory: null,
        giftId: null,
        langMaps: [],
        quizUrl: null,
        files: null,
        frontCoverImg: {
          fileUrl: "images/E-learning/banner-fake/e-learning fake-07.jpg",
          fullFileUrl: null,
          type: 0,
          sortOrder: 0,
        },
      },

      statusObj: [],
      period: [],
      applyObj: [],
      multipleSelection: [],
      categoryList: [],
      page: 1, //当前页数
      pagesize: 100, //一页显示几条
      total: null,
      sortType: "ASC",
      sortField: "sortOrder",
      activeNames: ["1", "2"],
      subGroupList: [],
      statusObj: [],
      canDrag: false,
      uploadErr: false,
      searchName: ''
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
  },
  components: {
    StatusBtn,
  },
  watch: {
    _language: function () {
      this.setObj();
    },
    detailInfo: {
      handler: function () {
        this.$store.state.edit = true;
      },
      deep: true,
    },
  },
  created() {
    var obj = [];
    for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
      obj.push({
        langCode: this.$store.state.userInfo.language[i].langCode,
        title: "",
      });
    }
    if (this.checkPermission("J Channel_LIST_ORDER")) {
      this.canDrag = true;
    }
    this.$set(this.detailInfo, "langMaps", obj);
    this.init();
    this.getSubList();
  },
  mounted() {
    const table = document.querySelector(".el-table__body-wrapper tbody");
    var self = this;
    Sortable.create(table, {
      onEnd({ newIndex, oldIndex }) {
        self.updateNewsOrder(newIndex, oldIndex);
      },
      filter: ".disabled",
      onMove: (event) => {
        return !event.related.classList.contains("disabled");
      },
    });
  },
  methods: {
    handleSizeChange(val) {
      this.pagesize = val
      this.getSubList()
    },
    handleCurrentChange(val) {

      this.page = val
      this.getSubList()
    },
    setObj: function () {
      this.statusObj = [
        {
          value: 0,
          label: "Draft",
        },
        {
          value: 1,
          label: "Pending approval",
        },
        {
          value: 2,
          label: "Pending Publish",
        },
        {
          value: 3,
          label: "Rejected",
        },
        {
          value: 4,
          label: "Suspended",
        },
        {
          value: 5,
          label: "Pending Suspend",
        },
        {
          value: 6,
          label: "Published",
        },
      ];
      this.applyObj = [
        {
          value: 0,
          label: "All User",
        },
        {
          value: 1,
          label: "Active User",
        },
      ];
    },
    async init() {
      let id = this.$route.query.id;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.eLearningDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        delete data.data.result["userId"];
        if (!data.data.result.frontCoverImg) {
          data.data.result.frontCoverImg = {};
        }
        this.$set(this, "detailInfo", data.data.result);
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      } else {
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      }
      this.setObj();
    },
    async getSubList() {
      var objdata = this.getAuthObj();

      objdata.pageIndex = this.page;
      objdata.pageSize = this.pagesize;
      objdata.title = this.searchName
      objdata.sortName = this.sortField;
      objdata.sortType = this.sortType;
      objdata.parentId = this.$route.query.id;
      objdata.apiUrl = this.apiConfig.eLearningList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.subGroupList = data.data.result["e-learning"];
      let list = null;
      for (list of this.subGroupList) {
        list.updatedAt = this.dateFormat(list.updatedAt);
        if (list.status === 0) {
          list.statusName = "Draft";
        } else if (list.status == 1) {
          list.statusName = "Pending approval";
        } else if (list.status == 2) {
          list.statusName = "Pending Publish";
        } else if (list.status == 3) {
          list.statusName = "Rejected";
        } else if (list.status == 4) {
          list.statusName = "Suspended";
        } else if (list.status == 5) {
          list.statusName = "Pending Suspend";
        } else if (list.status == 6) {
          list.statusName = "Published";
        }
      }
      this.setObj();

      this.total = data.data.result.total;
    },
    cell: function ({ row }) {
      if (!this.canDrag) {
        return "disabled pointer";
      }
      // if (row.status == 1) {
      return "cursor-move";
      // } else {
      //   return "disabled pointer";
      // }
    },
    async updateNewsOrder(newIndex, oldIndex) {
      var item = this.subGroupList[oldIndex];
      this.subGroupList.splice(oldIndex, 1);
      this.subGroupList.splice(newIndex, 0, item);
      let sortOrder = [];
      let objdata = this.getAuthObj();
      for (let i = 0; i < this.subGroupList.length; i++) {
        sortOrder.push({
          id: this.subGroupList[i].id,
          displayOrder: this.subGroupList[i].sortOrder,
        });
      }
      objdata.lstOrderDTO = sortOrder;

      objdata.apiUrl = this.apiConfig.eLearningOrder;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.getSubList();
    },
    checkEvent: function () {
      this.$refs["detailInfo"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
                that.deleteList();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              },
            },
          ],
        });
      }
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        for (var key in this.detailInfo) {
          obj[key] = this.detailInfo[key];
        }
        var data;
        if (this.$route.query.id) {
          obj.id = this.detailInfo.id;
          obj.apiUrl = this.apiConfig.eLearningUpdate;
          data = await this.$store.dispatch("apiEvent", obj);
        } else {
          obj.apiUrl = this.apiConfig.eLearningCreate;
          data = await this.$store.dispatch("apiEvent", obj);
        }
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$router.go(-1);
        }
      } catch (err) { }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() { },
    async uploadFile(params) {
      if (!this.handleCheckUploadFileSize(params.file)) return false
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == this.TOKEN_EXPIRED) {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.detailInfo.frontCoverImg.fileUrl = data.data.result.url;
      this.detailInfo.frontCoverImg.fullFileUrl = data.data.result.showUrl;
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids.join(",");

      objdata.apiUrl = this.apiConfig.eLearningDelete;
      let data = await this.$store.dispatch("apiEventFromData", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
        this.getSubList();
      }
    },
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/e-learningSubDetail",
        query: {
          id: row.id,
          parentId: this.detailInfo.id,
        },
      });
    },
    gotoSubDetail() {
      this.$router.push({
        path: "/main/e-learningSubDetail",
        query: {
          parentId: this.detailInfo.id,
        },
      });
    },
    handleCheckUploadFileSize(file) {
      const sizeKB = file.size / 1024
      if (sizeKB > 5120) {
        this.uploadErr = true
        return false
      } else {
        this.uploadErr = false
        return true
      }

    }
  },
};
</script>
